<template>
  <form @submit.prevent="submit">
    <div class="row">
      <div class="col-md-4">
        <z-input
          v-model="phoneBusiness"
          name="phoneBusiness"
          label="Business Phone"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-6"></div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <z-input
          v-model="address1"
          name="address1"
          label="Address"
          @keyup="saveIt"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <z-input
          v-model="address2"
          name="address2"
          label="Address 2"
          @keyup="saveIt"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <z-input v-model="city" name="city" label="City" @keyup="saveIt" />
      </div>
      <div class="col-md-4">
        <z-select
          v-model="state"
          :options="states"
          label="State"
          @change="changeState"
        />
      </div>
      <div class="col-md-4">
        <z-input
          v-model="zipcode"
          name="zipcode"
          label="Zip Code"
          @keyup="saveIt"
        />
      </div>
    </div>
  </form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
export default {
  name: 'organization-address',
  components: {
    ZInput,
    ZSelect,
  },
  computed: {
    ...mapGetters('organizations', ['organization']),
    ...mapGetters('configuration', ['stateprovinces']),
    states() {
      let _data = []
      this.stateprovinces.forEach((element) => {
        _data.push({
          name: element.name,
          value: element.name,
        })
      })
      return _data
    },
    phoneBusiness: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.phone
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'phone',
          value: value,
        })
      },
    },
    address1: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.address1
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'address1',
          value: value,
        })
      },
    },
    address2: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.address2
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'address2',
          value: value,
        })
      },
    },
    city: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.city
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'city',
          value: value,
        })
      },
    },
    state: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.state
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'state',
          value: value,
        })
      },
    },
    zipcode: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.zipcode
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'zipcode',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('organizations', ['setOrganizationData']),
    saveIt() {
      this.$emit('saveIt')
    },
    changeState() {
      this.$emit('saveIt')
    },
    changeTimezone() {
      this.$emit('saveIt')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-allow {
  margin-left: 5px;
}
</style>
